export default __webpack_public_path__ + "static/media/kitchen3-afterA-1024w.abe0d3b2.avif";